import * as Actions from '../actions';
//import Utils from '../../../yeffect/utils';

/* const initialState = {
    role: 'guest',
    data: {
        'displayName': 'John Doe',
        'photoURL'   : 'assets/images/avatars/profile.jpg',
        'email'      : 'johndoe@withinpixels.com',
        shortcuts    : [
            'calendar',
            'mail',
            'contacts',
            'analytics-dashboard'
        ]
    }
}; */

const initialState = {
  role: 'unauthenticated',
  data: {
    'displayName': '',
    'photoURL'   : 'assets/images/avatars/profile.jpg',
    'email'      : '',
  }
};

const user = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_USER_DATA:
        {
            return {
                ...initialState,
                ...action.payload
            };
        }
        case Actions.REMOVE_USER_DATA:
        {
            return {
                ...initialState
            };
        }
        case Actions.USER_LOGGED_OUT:
        {
            return initialState;
        }
        default:
        {
            return state
        }
    }
};

export default user;
